import React, { ComponentType, SVGProps } from 'react';
import { createUseStyles } from 'react-jss';
import theme from '../constants/Theme';

interface IconButtonProps {
  icon: ComponentType<SVGProps<any>>;
  size?: number;
  onClick?: () => void;
  disabled?: boolean;
}

const IconButton: React.FC<IconButtonProps> = ({ icon: Icon, size = 40, onClick, disabled = false }) => {
  const styleProps: StyleProps = { size };
  const classes = useStyles(styleProps);

  return (
    <button className={`${classes.button}`} onClick={onClick} disabled={disabled}>
      <Icon />
    </button>
  );
};

type StyleProps = {
  size: number;
};

const useStyles = createUseStyles({
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    border: 'none',
    cursor: 'pointer',
    backgroundColor: theme.colors.contrastWhite,
    transition: 'all 0.2s ease',
    padding: 0,
    width: ({ size }: StyleProps) => size,
    height: ({ size }: StyleProps) => size,
    '&:active:not(:disabled)': {
      backgroundColor: theme.colors.functionalRedLight,
      transform: 'scale(0.95)',
    },
    '&:disabled': {
      cursor: 'not-allowed',
      opacity: 0.5,
    },
  },
});

export default IconButton;
